import React, { Fragment, useEffect, useState } from "react";
import {
    DatePickerComponent,
    FormActionComponent,
    FormWrapperInputComponent,
    FormWrapperItem,
    HeaderListComponent,
    LoadingComponent,
    PageListComponent
} from "../../../common/component/Index";
import { CAMPAIGN, DATE_TIME_FORMAT, DETAIL_ACTIONS, MARKUP, PROMOTION } from "../../../../../constants/Define";
import { useTranslation } from "react-i18next";
import AntSelect, { AntOption } from "../../../common/component/AntSelect";
import { capitalizeFirstLetter, checkUndefine, multipleValidate, formatValidation, findParentRoute, vietnameseStringToUnicode } from "../../../../../helpers/functions";
import Wrapper from "../../../common/component/Wrapper";
import Input from "../../../common/component/Input";
import Radio from "../../../common/component/Radio";
import { find, toArray } from "lodash";
import { Button, Checkbox, Icon, Tooltip, Upload } from "antd";
import moment from "moment";
import Span from "../../../common/component/Span";
import './BundleDetail.less';
import PromotionCodes from "./PromotionCodes";
import PromotionDateLimit from "./PromotionDateLimit";

const BundleDetail = ({ ...props }) => {
    const intValue = {
        timeToApply: 1,
        name: '',
        count: '',
        startDate: null,
        endDate: null,
        stayStartDate: null,
        stayEndDate: null,
        loyaltyBenefitCode: '',
        code: '',
        isCheckExpiredCard: false,
        isCheckExpiredVoucher: false,
        checkinDateLimitType: CAMPAIGN.DATE_LIMIT.HAS_RESTRICTION.subOptions[0].data,
        checkinDateLimitValue: {
            dateRanges: null,
            dates: null,
            dayOfWeek: null,
        },
    }
    const { t } = useTranslation();
    const { match, promotionState, getAllCampaign, createBundlesDetails, getBundlesDetails, updateBundlesDetails } = props;
    const { campaigns, isFetchingCampaign, isFetchingUpsert, bundle: bundleReducer, bundleDetail } = promotionState;
    const [action, setAction] = useState(DETAIL_ACTIONS.CREATE);
    const [bundle, setBundle] = useState({ ...bundleReducer, ...intValue });
    const [validation, setValidation] = useState({});
    const [isSubmit, setIsSubmit] = useState(false);
    const [campaignsValue, setCampaignsValue] = useState([]);
    const [bundleApplyConfig, setBundleApplyConfig] = useState({});
    const [allowCreateBundle, setAllowCreateBundle] = useState(false);
    const [allowUpdateBundle, setAllowUpdateBundle] = useState(false);
    const [isHotelProductType, setIsHotelProductType] = useState(false);
    const [productType, setProductType] = useState([]);
    const [promotionCode, setPromotionCode] = useState('');
    const [isShowImportPromotion, setIsShowImportPromotion] = useState(false);
    const [promotionMaxCodeCount, setPromotionMaxCodeCount] = useState(0);
    const [isLoyaltyVoucher, setIsLoyaltyVoucher] = useState(false);

    const isSkuProductType = (types = productType) => {
        return Array.isArray(types) && types.includes(CAMPAIGN.PRODUCT_TYPE.SKU.id);
    }

    const isRequiredLoyaltyBenefitCode = action !== DETAIL_ACTIONS.UPDATE && isLoyaltyVoucher;

    useEffect(() => {
        getAllCampaign && getAllCampaign();
        loadInitBundleDetail();
    }, []);

    useEffect(() => {
        if (campaigns && campaigns.length > 0) {
            setCampaignsValue(campaigns);
        }
    }, [campaigns]);

    useEffect(()=>{
        if (bundleDetail && bundleDetail.id && action === DETAIL_ACTIONS.UPDATE) {
            setAllowUpdateBundle(true);
            const campaignData = campaigns.filter(item => {
                return item.id === bundleDetail.campaignId;
            });
            let timeCampaign = {campaignStartTime: null, campaignEndTime: null};
            if (campaignData && campaignData.length > 0) {
                const data = campaignData[0];
                const currentProductType = data.productType || [];
                timeCampaign = {
                    campaignStartTime: data.startTime ? moment(data.startTime) : null,
                    campaignEndTime: data.endTime ? moment(data.endTime) : null
                }
                setProductType(currentProductType);
                setIsHotelProductType(currentProductType.includes(CAMPAIGN.PRODUCT_TYPE.HOTEL.id));
                setIsShowImportPromotion(data.codeType === CAMPAIGN.CODE_TYPE.CUSTOMIZE.id);
                setPromotionMaxCodeCount(data.maxCodeCount);
                setIsLoyaltyVoucher(data.isLoyaltyVoucher);
            } else {
                setProductType([]);
            }
            
            setBundle({
                ...bundleDetail,
                startDate: bundleDetail.startDate ? moment.utc(bundleDetail.startDate).local() : null,
                endDate: bundleDetail.endDate ? moment.utc(bundleDetail.endDate).local() : null,
                stayStartDate: bundleDetail.stayStartDate ? moment(bundleDetail.stayStartDate) : null,
                stayEndDate: bundleDetail.stayEndDate ? moment(bundleDetail.stayEndDate) : null,
                timeToApply: (bundleDetail.dayOfWeek && Object.keys(bundleDetail.dayOfWeek).length > 0) ? 2 : 1,
                checkinDateLimitValue: bundleDetail.checkinDateLimitValue || {
                    dateRanges: null,
                    dates: null,
                    dayOfWeek: null,
                },
                ...timeCampaign
            });
            setBundleApplyConfig((bundleDetail.dayOfWeek && Object.keys(bundleDetail.dayOfWeek).length > 0) ? bundleDetail.dayOfWeek : {});
        }
    }, [bundleDetail, campaigns]);

    function loadInitBundleDetail(){
        const { match } = props;
        if (Object.keys(match.params).length > 0) {
            if(!!match.params.id){
                setAction(DETAIL_ACTIONS.UPDATE);
                getBundlesDetails(match.params.id);
            }
        }
    }

    const onChangeExpiredCard = (e) => {
        setBundle({
            ...bundle,
            isCheckExpiredCard: e.target.checked,
        })
        return;
    }
    const onChangeExpiredVoucher = (e) => {
        setBundle({
            ...bundle,
            isCheckExpiredVoucher: e.target.checked,
        });
        return;
    }
    const onChangeCampaignValue = (name, value) => {
        const currentCampaign = campaigns;
        if (currentCampaign && currentCampaign.length > 0) {
            const campaignData = currentCampaign.filter(item => {
                return item.id === value
            });
            if (campaignData && campaignData.length > 0) {
                const data = campaignData[0];
                const currentProductType = data.productType || [];
                const intMaxCount = parseInt(data.maxCount);
                onChangeDetail('campaignStartTime', data.startTime ? moment(data.startTime) : null);
                onChangeDetail('campaignEndTime', data.endTime ? moment(data.endTime) : null);
                onChangeDetail('maxCount', data.maxCount);
                setAllowCreateBundle(data.startTime && data.endTime && intMaxCount > 0);
                setIsHotelProductType(currentProductType.includes(CAMPAIGN.PRODUCT_TYPE.HOTEL.id));
                setProductType(currentProductType);
                setIsShowImportPromotion(data.codeType === CAMPAIGN.CODE_TYPE.CUSTOMIZE.id);
                setPromotionMaxCodeCount(data.maxCodeCount);
                setIsLoyaltyVoucher(data.isLoyaltyVoucher);
            } else {
                setAllowCreateBundle(false);
                setProductType([]);
                setIsShowImportPromotion(false);
                setPromotionMaxCodeCount(0);
                setIsLoyaltyVoucher(false)
            }
        }
        onChangeDetail(name, value);
        clearValue();
        onResetValidation();
    }

    const onChangeDetail = (name, value) => {
        const oldBundle = bundle;
        if (name === 'count' && value) {
            const intValue = parseInt(value);
            const intMaxCount = isShowImportPromotion ? parseInt(promotionMaxCodeCount || 0) : parseInt(oldBundle.maxCount || 0);
            value = intValue > intMaxCount ? intMaxCount : value;
        }
        oldBundle[name] = value;
        setBundle({ ...oldBundle });
        // clear days apply
        if (name === 'timeToApply' && value === 1) {
            const oldValidate = validation;
            setBundleApplyConfig({});
            setValidation({ ...oldValidate, bundleApplyConfig: null });
        }
    }

    const formatCheckinDateLimitValue = (checkinDateLimitValue) => {
        if (!checkinDateLimitValue) return checkinDateLimitValue;
        
        const formatted = { ...checkinDateLimitValue };
        const toISO = (date) => new Date(date).toISOString();

        if (formatted.dates && Array.isArray(formatted.dates)) {
            formatted.dates = formatted.dates.map(toISO);
        }
        
        if (formatted.dateRanges && Array.isArray(formatted.dateRanges)) {
            formatted.dateRanges = formatted.dateRanges.map(range => ({
                ...range,
                fromDate: toISO(range.fromDate),
                toDate: toISO(range.toDate)
            }));
        }
        
        if (formatted.dayOfWeek) {
            formatted.dayOfWeek = {
                ...formatted.dayOfWeek,
                fromDate: toISO(formatted.dayOfWeek.fromDate),
                toDate: toISO(formatted.dayOfWeek.toDate)
            };
        }
        
        return formatted;
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        if (validate()) {
            const shouldSubmitDateRestriction = isSkuProductType();
            const request = {
                ...bundle,
                dayOfWeek: bundleApplyConfig,
                stayStartDate: shouldSubmitDateRestriction ? null : bundle.stayStartDate,
                stayEndDate: shouldSubmitDateRestriction ? null : bundle.stayEndDate,
                isCheckExpiredCard: shouldSubmitDateRestriction ? false : bundle.isCheckExpiredCard,
                isCheckExpiredVoucher: bundle.isCheckExpiredVoucher,
                checkinDateLimitType: shouldSubmitDateRestriction ? bundle.checkinDateLimitType : CAMPAIGN.DATE_LIMIT.NONE.data,
                checkinDateLimitValue: shouldSubmitDateRestriction ? formatCheckinDateLimitValue(bundle.checkinDateLimitValue) : {
                    dateRanges: null,
                    dates: null,
                    dayOfWeek: null,
                }
            }
            
            if (action === DETAIL_ACTIONS.CREATE) {
                createBundlesDetails(request);
            } else {
                updateBundlesDetails(request);
            }
        } else {
            setIsSubmit(false);
        }
    }

    const clearValue = () => {
        const oldBundle = bundle;
        setBundle({ ...oldBundle, ...intValue });
        setBundleApplyConfig({});
    }

    const createValidationError = (fieldName) => ({
        classError: "hms-error-form",
        messageError: capitalizeFirstLetter(t('validation.statusCode.code.1').replace('%s', t(`item.bundle.${fieldName}`)).toLowerCase())
    });

    const validateCheckinDateLimitFields = (checkinDateLimitValue, checkinDateLimitType) => {
        const { DATE_LIMIT } = CAMPAIGN;
        const result = {};
        
        if (!checkinDateLimitValue) return result;
        
        switch (checkinDateLimitType) {
            case DATE_LIMIT.HAS_RESTRICTION.subOptions[0].data:
                if (!checkinDateLimitValue.dates?.length) {
                    result.checkinDateLimitValue = createValidationError('applyDates');
                }
                break;
            case DATE_LIMIT.HAS_RESTRICTION.subOptions[1].data:
                if (!checkinDateLimitValue.dateRanges?.length) {
                    result.checkinDateLimitValueDateRange = createValidationError('applyDateRanges');
                }
                break;
            case DATE_LIMIT.HAS_RESTRICTION.subOptions[2].data:
                const { dayOfWeek } = checkinDateLimitValue;
                if (!dayOfWeek?.fromDate || !dayOfWeek?.toDate) {
                    result.checkinDateLimitValueDateRange = createValidationError('applyDateRanges');
                }
                if (!dayOfWeek?.daysOfWeek?.length) {
                    result.checkinDateLimitValueDaysOfWeek = createValidationError('applyDaysOfWeek');
                }
                break;
        }
        
        return result;
    };

    const validate = () => {
        const validate = {
            required: {
                campaignId: formatValidation(t('validation.statusCode.code.1'), t(`item.bundle.campaign`)),
                name: formatValidation(t('validation.statusCode.code.1'), t(`item.bundle.name`)),
                count: formatValidation(t('validation.statusCode.code.1'), t(`item.bundle.count`)),
            }
        };
        
        let valueValidate = {};
        if (isShowImportPromotion) {
            delete validate.required[`count`];
        }
        if(isRequiredLoyaltyBenefitCode) {
            validate.required.loyaltyBenefitCode = formatValidation(t('validation.statusCode.code.1'), t(`item.bundle.loyaltyBenefitCode`));
        }
        let result = multipleValidate(bundle, validate, valueValidate);
        
        if (isSkuProductType() && bundle.checkinDateLimitType && bundle.checkinDateLimitType !== CAMPAIGN.DATE_LIMIT.NONE.data) {
            const checkinDateLimitValidation = validateCheckinDateLimitFields(bundle.checkinDateLimitValue, bundle.checkinDateLimitType);
            result = { ...result, ...checkinDateLimitValidation };
        }
        
        if (isShowImportPromotion && (bundle.promotionCodes === undefined || bundle.promotionCodes.length <= 0) && !isLoyaltyVoucher) {
            result = {
                ...result,
                promotionCodes: {
                    classError: "hms-error-form",
                    messageError: capitalizeFirstLetter(t('validation.statusCode.code.1').replace('%s', t(`item.bundle.promotionCode`)).toLowerCase())
                }
            }
        }
        if (bundle.timeToApply === PROMOTION.BUNDLE_APPLY_TIME.SOME.id && Object.keys(bundleApplyConfig).length <= 0) {
            const resultTimeToApply = {
                bundleApplyConfig: {
                    classError: "hms-error-form",
                    messageError: capitalizeFirstLetter(t('validation.statusCode.code.1').replace('%s', t(`item.bundle.timeToApplyType`)).toLowerCase())
                }
            }
            result = {
                ...result,
                ...resultTimeToApply,
            }
        }
        setValidation(result);
        return Object.keys(result).length < 1;
    }

    const onChangeBundleConfigDetail = (dayKey, currentValue) => {
        const oldBundleApplyConfig = bundleApplyConfig;
        oldBundleApplyConfig[dayKey] = currentValue;
        setBundleApplyConfig({ ...oldBundleApplyConfig });
    }

    const disabledBundleDate = (current, isStayDate = false) => {
        const currentBundle = bundle;
        const start = currentBundle.campaignStartTime;
        const end = currentBundle.campaignEndTime;
        return isStayDate ? !current.isAfter(start)
            : !current.isBetween(start, end, 'dates', '[]')
    }

    const disabledDateUse = (current) => {
        const currentBundle = bundle;
        if(Object.keys(currentBundle).length > 0){
            return current < moment(new Date(currentBundle.campaignStartTime)).startOf('day')
             || current > moment(new Date(currentBundle.campaignEndTime)).startOf('day').add(1, 'day');
        }
        return current < moment().startOf('day');
    }

    const onSelectedChangeDate = (data, name = '') => {
        const startDate = data.fullValue[0];
        const endDate = data.fullValue[1];
        const currentBundle = bundle;
        setBundle({ ...currentBundle, [name ? `${ name.toLowerCase() }StartDate` : `startDate`]: startDate, [name ? `${ name.toLowerCase() }EndDate` : `endDate`]: endDate });
    }

    const selectFilterSearch = (input, option) => {
        const optionText = vietnameseStringToUnicode(option?.props?.children?.props?.children.toLowerCase());
        const inputText = vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    const onChangeCheckinDateLimitValue = (checkinDateLimitValue) => {
        setBundle(prev => ({
            ...prev,
            checkinDateLimitValue
        }));
    };

    const onChangeCheckinDateLimitType = (checkinDateLimitType) => {
        setBundle(prev => ({
            ...prev,
            checkinDateLimitType
        }));
    };

    const onResetValidation = () => {
        setValidation(prev => {
            const newValidation = { ...prev };
            delete newValidation.checkinDateLimitValue;
            delete newValidation.checkinDateLimitValueDateRange;
            delete newValidation.checkinDateLimitValueDaysOfWeek;
            return newValidation;
        });
    };

    return (
        <Fragment>
            <LoadingComponent spinning={ isFetchingUpsert }>
                <PageListComponent className="bundle-detail-page">
                    <HeaderListComponent
                        path={ match.path }
                        groupPath={ 'bundle' }
                        titleHeader={ action === DETAIL_ACTIONS.CREATE
                            ? capitalizeFirstLetter((`${ t('action.create') } ${ t('item.bundle.title') }`).toLowerCase())
                            : capitalizeFirstLetter((`${ t('action.update') } ${ t('item.bundle.title') }`.toLowerCase()))
                        }
                        componentRight={ null }
                    />
                    <FormActionComponent
                        onSubmit={ onSubmit }
                        isSubmit={ isFetchingUpsert }
                        action={ action }
                        isGetItem={ false }
                        findParentRoute={ () => findParentRoute('promotions', props) }
                        submitButtonRight={ true }
                    >
                        <FormWrapperItem>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    typeInput={ true }
                                    isRequired={ 'right' }
                                    isValidation={ true }
                                    validation={ validation.campaignId }
                                    messageBelowInput={ true }
                                    labelTitle={ t(`item.bundle.campaign`) }
                                >
                                    <AntSelect className="select-departure"
                                               showArrow showSearch
                                               disabled={allowUpdateBundle}
                                               placeholder={ capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.bundle.campaign")).toLowerCase()) }
                                               onChange={ (e) => onChangeCampaignValue('campaignId', e) }
                                               style={ { width: '100%' } }
                                               value={ bundle.campaignId }
                                               loading={ isFetchingCampaign }
                                               filterOption={ (inputValue, option) => selectFilterSearch(inputValue, option) }
                                    >
                                        { (campaignsValue || []).map(campaign => (
                                            <AntOption key={ campaign.id } value={ campaign.id }>
                                                <Tooltip title={ campaign.name } placement="topLeft">{ `${ campaign.code } - ${ campaign.name }` }</Tooltip>
                                            </AntOption>
                                        )) }
                                    </AntSelect>
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    typeInput={ true }
                                    labelTitle={ t(`item.bundle.campaignDate`) }
                                >
                                    <DatePickerComponent className={ `form-control applyDates w100-percent disable-with-clear-text` }
                                                         hmsComponent={ `RangePicker` } format={ DATE_TIME_FORMAT.SHORT_DATE }
                                                         style={ { padding: 0, border: 0 } }
                                                         name={ `applyDates` }
                                                         placeholder={ [t('placeHolderForm.startDate'), t('placeHolderForm.endDate')] }
                                                         disabled={ true }
                                                         value={ [bundle.campaignStartTime, bundle.campaignEndTime] }
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    typeInput={ true }
                                    isRequired={ 'right' }
                                    isValidation={ true }
                                    messageBelowInput={ true }
                                    labelTitle={ t(`item.bundle.name`) }
                                    validation={ validation.name }
                                >
                                    <Input placeholder="" type={ `text` }
                                           className={ `form-control` }
                                           name={ `name` } onChange={ (e) => onChangeDetail('name', e.target.value) }
                                           value={ checkUndefine(bundle.name) }
                                           disabled={ !allowCreateBundle || allowUpdateBundle }
                                           autoComplete="off"
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    typeInput={ true }
                                    labelTitle={ t(`item.bundle.count`) }
                                    isRequired={ (isShowImportPromotion && isLoyaltyVoucher) ? '' : 'right' }
                                    isValidation={ !isShowImportPromotion && !isLoyaltyVoucher }
                                    messageBelowInput={ !isShowImportPromotion && !isLoyaltyVoucher }
                                    validation={ validation.count }
                                >
                                    <Input placeholder=""
                                           className={ `form-control` }
                                           name={ `count` } onChange={ (e) => onChangeDetail('count', Number(e.target.value)) }
                                           value={ checkUndefine(bundle.count) } type={ `number` }
                                           disabled={ !allowCreateBundle || isShowImportPromotion || allowUpdateBundle || isLoyaltyVoucher}
                                           autoComplete="off"
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    typeInput={ true }
                                    labelTitle={ t(`item.bundle.usedDate`) }
                                    messageBelowInput={ true }
                                >
                                    <DatePickerComponent className={ `form-control applyDates w100-percent` }
                                                         hmsComponent={ `RangePicker` } format={ DATE_TIME_FORMAT.DATE_TIME }
                                                         showTime={ { format: DATE_TIME_FORMAT.SHORT_TIME } }
                                                         style={ { padding: 0, border: 0 } }
                                                         name={ `applyDates` }
                                                         placeholder={ [t('placeHolderForm.startDate'), t('placeHolderForm.endDate')] }
                                                         disabled={ !allowUpdateBundle && !allowCreateBundle }
                                                         disabledDate={ (current) => disabledDateUse(current) }
                                                         onChange={ (date) => onSelectedChangeDate(date) }
                                                         value={ [bundle.startDate, bundle.endDate] }
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-6">
                                { !isSkuProductType() && (
                                    <FormWrapperInputComponent
                                        typeInput={ true }
                                        labelTitle={ t(`item.bundle.stayDate`) }
                                        messageBelowInput={ true }
                                    >
                                        <DatePickerComponent className={ `form-control applyDates w100-percent` }
                                            hmsComponent={ `RangePicker` } format={ DATE_TIME_FORMAT.SHORT_DATE }
                                            style={ { padding: 0, border: 0 } }
                                            name={ `applyDates` }
                                            placeholder={ [t('placeHolderForm.startDate'), t('placeHolderForm.endDate')] }
                                            disabled={ (allowUpdateBundle && !bundle.isCampaignHotelType) || (!allowUpdateBundle && (!allowCreateBundle || !isHotelProductType)) }
                                            disabledDate={ (current) => disabledBundleDate(current, true) }
                                            onChange={ (date) => onSelectedChangeDate(date, 'stay') }
                                            value={ [bundle.stayStartDate, bundle.stayEndDate] }
                                        />
                                    </FormWrapperInputComponent>
                                ) }
                            </Wrapper>

                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    typeInput={ true }
                                    // isRequired={ 'right' }
                                    // isValidation={ true }
                                    messageBelowInput={ true }
                                    labelTitle={ t(`item.bundle.code`) }
                                    validation={ validation.code }
                                >
                                    <Input placeholder="" type={ `text` }
                                        className={ `form-control` }
                                        name={ `code` } onChange={ (e) => onChangeDetail('code', e.target.value) }
                                        value={ checkUndefine(bundle.code) }
                                        disabled={ true }
                                        autoComplete="off"
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>

                            <Wrapper className="col-md-6">
                                {/* <FormWrapperInputComponent
                                    typeInput={ true }
                                >
                                    <Checkbox
                                        checked={bundle.isCheckExpiredCard}
                                        onChange={(e) => onChangeExpiredCard(e)}
                                    >
                                        { t(`item.bundle.cardExpired`) }
                                    </Checkbox>
                                    <Checkbox
                                        checked={bundle.isCheckExpiredVoucher}
                                        onChange={(e) => onChangeExpiredVoucher(e)}
                                    >
                                        { t(`item.bundle.voucherExpired`) }
                                    </Checkbox>
                                </FormWrapperInputComponent> */}
                            </Wrapper>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    typeInput={ true }
                                    labelTitle={ t(`item.bundle.timeToApplyType`) }
                                >
                                    <Radio.Group value={ bundle.timeToApply }
                                                 disabled={ !allowCreateBundle || allowUpdateBundle }
                                                 onChange={ e => onChangeDetail('timeToApply', e.target.value) }>
                                        { toArray(PROMOTION.BUNDLE_APPLY_TIME).map(status => !status.hide && (
                                            <Radio key={ status.key } value={ status.id }>{ t(`item.bundle.${ status.key }`) }</Radio>
                                        )) }
                                    </Radio.Group>
                                </FormWrapperInputComponent>
                                { bundle.timeToApply === PROMOTION.BUNDLE_APPLY_TIME.SOME.id &&
                                <FormWrapperInputComponent
                                    typeInput={ true }
                                    labelTitle=""
                                    isValidation={ bundle.timeToApply === PROMOTION.BUNDLE_APPLY_TIME.SOME.id }
                                    validation={ validation.bundleApplyConfig }
                                    messageBelowInput={ true }
                                >
                                    <Wrapper className={ `ant-btn-group applyDays ${ validation.bundleApplyConfig && validation.bundleApplyConfig.classError ? `error-bundle-apply-config` : `` }` }>
                                        { (moment.localeData('en').weekdays() || []).map(day => {
                                            const dayKey = day.toLowerCase();
                                            return <Span key={ dayKey }
                                                         disabled={ allowUpdateBundle }
                                                         className={ `ant-btn ant-btn-${ bundleApplyConfig[dayKey] ? 'primary' : 'default' }` }
                                                         onClick={ e => onChangeBundleConfigDetail(dayKey, !bundleApplyConfig[dayKey]) }
                                            >{ t(`item.ticket.${ dayKey }`) }</Span>
                                        }) }
                                    </Wrapper>
                                </FormWrapperInputComponent>
                                }
                            </Wrapper>

                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    typeInput={ true }
                                    isRequired={ !isRequiredLoyaltyBenefitCode ? '' : 'right' }
                                    isValidation={ isRequiredLoyaltyBenefitCode }
                                    messageBelowInput={ isRequiredLoyaltyBenefitCode }
                                    labelTitle={ t(`item.bundle.loyaltyCampaignCode`) }
                                    validation={ validation.loyaltyBenefitCode }
                                >
                                    <Input
                                        type={ `text` }
                                        className={ `form-control` }
                                        placeholder={ isRequiredLoyaltyBenefitCode ? capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.bundle.loyaltyCampaignCode"))) : '' }
                                        name={ `loyaltyBenefitCode` } onChange={ (e) => onChangeDetail('loyaltyBenefitCode', e.target.value.trimLeft()) }
                                        value={ checkUndefine(bundle.loyaltyBenefitCode) }
                                        disabled={ !allowCreateBundle || allowUpdateBundle || !isLoyaltyVoucher }
                                        autoComplete="off"
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>

                            <Wrapper className="col-md-6">
                                { !isLoyaltyVoucher && isShowImportPromotion &&
                                <FormWrapperInputComponent
                                    labelTitle={ t(`item.bundle.promotionCode`) }
                                    typeInput={ true }
                                    isValidation={ isShowImportPromotion }
                                    validation={ validation.promotionCodes }
                                    messageBelowInput={ true }
                                >
                                    <PromotionCodes
                                        onChange={ onChangeDetail }
                                        lstPromotionCodes={ bundle.promotionCodes }
                                        maxCodeCount={ promotionMaxCodeCount }
                                    />
                                </FormWrapperInputComponent>
                                }
                            </Wrapper>

                            <Wrapper className="col-md-12">
                                { bundle.campaignId && bundle.maxCount !== undefined && !isShowImportPromotion ?
                                    <FormWrapperInputComponent
                                        labelTitle={ t(`item.bundle.maxCountInput`) }
                                    >
                                        { ` ` + (bundle.maxCount ? bundle.maxCount.toLocaleString() : bundle.maxCount) }
                                    </FormWrapperInputComponent> :
                                    (isShowImportPromotion && <FormWrapperInputComponent
                                        labelTitle={ t(`item.bundle.maxCountCode`) }
                                    >
                                        { ` ` + (promotionMaxCodeCount ? promotionMaxCodeCount.toLocaleString() : promotionMaxCodeCount) }
                                    </FormWrapperInputComponent>)
                                }
                            </Wrapper>

                                <Fragment>
                                    <PromotionDateLimit 
                                        bundle={bundle}
                                        validation={validation}
                                        disabledDateUse={disabledDateUse}
                                        onChangeCheckinDateLimitValue={onChangeCheckinDateLimitValue}
                                        onChangeCheckinDateLimitType={onChangeCheckinDateLimitType}
                                        onResetValidation={onResetValidation}
                                    />

                                    <Wrapper className="col-md-6">
                                        <FormWrapperInputComponent
                                            labelTitle={ t(`item.bundle.loyaltyCodeDateRestriction`) }
                                        >
                                            <Wrapper className="col-md-12 m-0 p-0">
                                                <Checkbox
                                                    checked={bundle.isCheckExpiredVoucher}
                                                    onChange={(e) => onChangeExpiredVoucher(e)}
                                                >
                                                    { t(`item.bundle.voucherExpired`) }
                                                </Checkbox>
                                            </Wrapper>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                </Fragment>
                            
                            <Wrapper className="col-md-6"/>
                            { productType && productType.length > 0 &&
                                <Wrapper className="col-md-6">
                                    <FormWrapperInputComponent
                                        labelTitle={ t(`item.bundle.productType`) }
                                    >
                                        { ` ` + productType.map(item => find([...toArray(CAMPAIGN.PRODUCT_TYPE), ...toArray(MARKUP.CAMPAIGN_TYPE)], type => type.id === item)?.label).join(', ') }
                                    </FormWrapperInputComponent>
                                </Wrapper>
                            }
                        </FormWrapperItem>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        </Fragment>
    )
}

export default BundleDetail;
